// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"f63401a9","707":"381f8b96","729":"01ecd5c8"}[chunkId] + ".js";
};